import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";

export type PracticePathCheckerResultDialogCheck = {
  criticalPointUuid: string;
  criticalPointTitle: string;
  isOk: boolean;
  reason?: string;
};

export type PracticePathCheckerResultDialogData = {
  workflowId: string;
  practicePathUuid: string;
  checks: PracticePathCheckerResultDialogCheck[];
  onOpenCriticalPoint?: (criticalPointUuid: string) => void;
};

export type PracticePathCheckerResultDialogClosePayload = {
  action: "openCriticalPoint";
  criticalPointUuid: string;
};

@Component({
  selector: "app-practice-path-checker-result-dialog",
  templateUrl: "./practice-path-checker-result-dialog.component.html",
  styleUrls: ["./practice-path-checker-result-dialog.component.scss"],
})
export class PracticePathCheckerResultDialogComponent {
  protected readonly failedChecks: PracticePathCheckerResultDialogCheck[];
  protected readonly successfulChecksCount: number;

  constructor(
    private dialogRef: MatDialogRef<
      PracticePathCheckerResultDialogComponent,
      PracticePathCheckerResultDialogClosePayload
    >,
    @Inject(MAT_DIALOG_DATA)
    protected readonly data: PracticePathCheckerResultDialogData
  ) {
    this.failedChecks = data.checks.filter((check) => check.isOk === false);
    this.successfulChecksCount = data.checks.length - this.failedChecks.length;
  }

  protected onTapOpenCriticalPoint(criticalPointUuid: string): void {
    if (this.data.onOpenCriticalPoint != null) {
      this.data.onOpenCriticalPoint(criticalPointUuid);
      return;
    }

    this.dialogRef.close({
      action: "openCriticalPoint",
      criticalPointUuid,
    });
  }

  public static open(
    dialogService: MatDialog,
    data: PracticePathCheckerResultDialogData
  ): MatDialogRef<
    PracticePathCheckerResultDialogComponent,
    PracticePathCheckerResultDialogClosePayload
  > {
    return dialogService.open<
      PracticePathCheckerResultDialogComponent,
      PracticePathCheckerResultDialogData,
      PracticePathCheckerResultDialogClosePayload
    >(PracticePathCheckerResultDialogComponent, {
      data,
      minWidth: "560px",
      maxWidth: "920px",
      width: "70vw",
    });
  }
}
